// @flow

import React from 'react';
import DefaultPage from './DefaultPage';
import { slides } from '../../content/careers';

type Props = {
    config: {
        sliderOptions: Object
    }
};

export const Careers = ({ config }: Props) => <DefaultPage slides={slides} config={config} />;
